import { v4 as uuidv4 } from 'uuid';

export const DEFAULT_TECHNICAL_DATA = {
    wc: {
        reference: '', nb_equipment: 1, water_quality_in: 'drinkable',
        flush_type: 'dual_flush', built_in: false, is_water_tank: true,
        consumption_reduction_system: false, flush_volume_min: 6, flush_volume_max: 9,
        general_comment: '', isolation_valve: true,
        is_small_flush_button: false, bascule_flush_possible: false
    },
    faucet: {
        reference: '', nb_equipment: 1, water_quality_in: 'drinkable',
        hot_water: true, activation_mode: 'single_handle', foamer: false,
        isolation_valve: false, max_flow: 6, max_flow_unit: 'L/min',
        general_comment: '', faucet_type: ''
    },
    shower: {
        reference: '', nb_equipment: 1, water_quality_in: 'drinkable',
        hot_water: true, activation_mode: 'single_handle',
        consumption_reduction_system: false, isolation_valve: false,
        max_flow: 15, max_flow_unit: 'L/min', general_comment: ''
    },
    machine: {
        reference: '', type_machine: '', nb_equipment: 1,
        water_quality_in: '', hot_water: false, volume_per_cycle: 0,
        volume_per_cycle_unit: 'L/cycle', custom_fields: {}, rate: 2.5,
        general_comment: '', isolation_valve: false,
    },
    urinal: {
        reference: '', nb_equipment: 1, consumption_reduction_system: false,
        water_quality_in: 'drinkable', flush_volume: 3,
        activation_mode: 'push_button', general_comment: '', isolation_valve: false,
    },
};

export const buildDefaultUsageForm = (type, equipmentId, roomData, buildingData) => {
    const baseUsageData = {
        nb_users: roomData?.person_count || 0,
        weekly_usage: buildingData?.building_usage?.weekly_usage || 5,
        yearly_usage: buildingData?.building_usage?.yearly_usage || 52,
        more_intense_weeks: buildingData?.building_usage?.more_intense_weeks || 0,
        less_intense_weeks: buildingData?.building_usage?.less_intense_weeks || 0,
    };

    const base = {
        _id: uuidv4(),
        _id_equipement: equipmentId,
        functional_unit: roomData?.functional_unit,
        possible_savings: true,
        is_known_volume: false,
        annual_volume: null,
    };

    // usage_category_id/usage_subcategory_id doivent rester synchronisés avec
    // DIC_USAGE_TAXONOMY_BY_EQUIPMENT dans api/utils.py. "machine" n'a pas de
    // valeur par défaut (cf. commentaire côté back) : un lave-linge, un
    // lave-vaisselle etc. peuvent relever de catégories très différentes,
    // donc on force un choix explicite via le picker plutôt que de deviner.
    const typeDefaults = {
        wc: {
            type_usage: 'Sanitaires', usage_category_id: 'tertiaire', usage_subcategory_id: 'tertiaire--sanitaires',
            water_quality_needed: 'non_drinkable',
            water_quality_out: 'non_drinkable',
            usage_data: { ...baseUsageData, daily_usage: 1.72, daily_usage_type: 'per_person' }
        },
        faucet: {
            type_usage: 'Hygiène', usage_category_id: 'tertiaire', usage_subcategory_id: 'tertiaire--lavage_des_mains',
            water_quality_needed: 'drinkable',
            water_quality_out: 'non_drinkable',
            usage_data: { ...baseUsageData, daily_usage: 1.32, daily_usage_type: 'per_person' }
        },
        shower: {
            type_usage: 'Douche', usage_category_id: 'tertiaire', usage_subcategory_id: 'tertiaire--douche',
            water_quality_needed: 'drinkable',
            water_quality_out: 'non_drinkable',
            usage_data: { ...baseUsageData, daily_usage: 4.04, daily_usage_type: 'per_person' }
        },
        machine: {
            type_usage: '', usage_category_id: null, usage_subcategory_id: null,
            water_quality_needed: 'non_drinkable',
            water_quality_out: 'non_drinkable',
            usage_data: { ...baseUsageData, daily_usage: 0, daily_usage_type: 'total', cycle_duration: null, daily_utilisation: null }
        },
        urinal: {
            type_usage: 'Sanitaires', usage_category_id: 'tertiaire', usage_subcategory_id: 'tertiaire--sanitaires',
            water_quality_needed: 'non_drinkable',
            water_quality_out: 'non_drinkable',
            usage_data: { ...baseUsageData, daily_usage: 1.34, daily_usage_type: 'per_person' }
        },
    };

    const td = typeDefaults[type];
    if (!td) return null;
    return { ...base, ...td };
};
